import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./MaatwerkIntro.css";
import { useTranslation, Trans } from "react-i18next";
import { Typography } from "@mui/material";
import { Box, Button, Divider } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";

const MaatwerkIntro = ({ module }) => {
  const navigate = useNavigate();
  const { search } = useLocation();
  const { t } = useTranslation();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.between("mobile", "ipad"));
  const isPurchase = module === "PURCHASE";

  function handleNext() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    if (isPurchase) {
      navigate(`/upload${search}`);
    } else {
      navigate(`/rental/upload${search}`);
    }
  }

  const iconColor = "#1A56A8";
  const whyItems = [
    {
      key: "understand",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 640 640"
          fill={iconColor}
        >
          <path d="M331.6 68.5L539.1 149L558.3 156.4L559.5 176.9C562.4 226.9 554.6 303.2 522.2 377.8C489.5 453 431.1 527.8 332.8 570.4L320.1 575.9L307.4 570.4C208.9 527.9 150.6 453.2 117.9 377.9C85.5 303.3 77.7 226.9 80.6 177L81.8 156.5L101 149L308.5 68.5L320 64L331.6 68.5zM377.4 233.8L291.8 351.6C272.5 331.6 258.1 316.7 248.6 306.9L214.1 340.2C220.3 346.6 241.3 368.3 277.2 405.4L297 426L313.8 402.9L416.2 262.1L430.3 242.7L391.5 214.5L377.4 233.9z" />
        </svg>
      ),
    },
    {
      key: "spot",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 640 640"
          fill={iconColor}
        >
          <path
            opacity=".4"
            d="M112.4 272C112.4 360.4 184 432 272.4 432C360.8 432 432.4 360.4 432.4 272C432.4 183.6 360.8 112 272.4 112C184 112 112.4 183.6 112.4 272z"
          />
          <path d="M432.4 272C432.4 183.6 360.8 112 272.4 112C184 112 112.4 183.6 112.4 272C112.4 360.4 184 432 272.4 432C360.8 432 432.4 360.4 432.4 272zM401.6 435.1C366.1 463.2 321.3 480 272.5 480C157.6 480 64.5 386.9 64.5 272C64.5 157.1 157.6 64 272.5 64C387.4 64 480.5 157.1 480.5 272C480.5 320.8 463.7 365.7 435.6 401.1L569.5 535L586.5 552L552.6 585.9L535.6 568.9L401.7 435z" />
        </svg>
      ),
    },
    {
      key: "avoid",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 640 640"
          fill={iconColor}
        >
          <path
            opacity=".4"
            d="M112 168C112 154.7 122.7 144 136 144L520 144C533.3 144 544 133.3 544 120L544 200.6C534.6 195.2 523.7 192 512 192L136 192C122.7 192 112 181.3 112 168z"
          />
          <path d="M128 96C92.7 96 64 124.7 64 160L64 448C64 483.3 92.7 512 128 512L512 512C547.3 512 576 483.3 576 448L576 256C576 220.7 547.3 192 512 192L136 192C122.7 192 112 181.3 112 168C112 154.7 122.7 144 136 144L520 144C533.3 144 544 133.3 544 120C544 106.7 533.3 96 520 96L128 96zM480 320C497.7 320 512 334.3 512 352C512 369.7 497.7 384 480 384C462.3 384 448 369.7 448 352C448 334.3 462.3 320 480 320z" />
        </svg>
      ),
    },
    {
      key: "questions",
      icon: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 640 640"
          fill={iconColor}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity=".4"
            d="M112 192L112 416C112 442.5 133.5 464 160 464L216 464C226.4 464 235.3 470.6 238.6 479.9C239.5 482.4 240 485.1 240 488L240 537.7C272.7 514.6 303.3 493 331.9 472.8C340 467.1 349.7 464 359.6 464L480 464C506.5 464 528 442.5 528 416L528 192C528 165.5 506.5 144 480 144L160 144C133.5 144 112 165.5 112 192zM160 296C160 282.7 170.7 272 184 272L312 272C325.3 272 336 282.7 336 296C336 309.3 325.3 320 312 320L184 320C170.7 320 160 309.3 160 296zM160 392C160 378.7 170.7 368 184 368L232 368C245.3 368 256 378.7 256 392C256 405.3 245.3 416 232 416L184 416C170.7 416 160 405.3 160 392zM304 392C304 378.7 314.7 368 328 368L456 368C469.3 368 480 378.7 480 392C480 405.3 469.3 416 456 416L328 416C314.7 416 304 405.3 304 392zM384 296C384 282.7 394.7 272 408 272L456 272C469.3 272 480 282.7 480 296C480 309.3 469.3 320 456 320L408 320C394.7 320 384 309.3 384 296z"
          />
          <path d="M267.7 576.9L267.7 576.9L359.6 512L480 512C533 512 576 469 576 416L576 192C576 139 533 96 480 96L160 96C107 96 64 139 64 192L64 416C64 469 107 512 160 512L192 512L192 584C192 593 197 601.2 205 605.3C213 609.4 222.6 608.8 229.9 603.6L267.7 576.9zM359.6 464C349.7 464 340 467.1 331.9 472.8C303.3 493 272.6 514.6 240 537.7L240 488C240 485.2 239.5 482.4 238.6 479.9C235.3 470.6 226.4 464 216 464L160 464C133.5 464 112 442.5 112 416L112 192C112 165.5 133.5 144 160 144L480 144C506.5 144 528 165.5 528 192L528 416C528 442.5 506.5 464 480 464L359.6 464zM184 272C170.7 272 160 282.7 160 296C160 309.3 170.7 320 184 320L312 320C325.3 320 336 309.3 336 296C336 282.7 325.3 272 312 272L184 272zM408 272C394.7 272 384 282.7 384 296C384 309.3 394.7 320 408 320L456 320C469.3 320 480 309.3 480 296C480 282.7 469.3 272 456 272L408 272zM184 368C170.7 368 160 378.7 160 392C160 405.3 170.7 416 184 416L232 416C245.3 416 256 405.3 256 392C256 378.7 245.3 368 232 368L184 368zM328 368C314.7 368 304 378.7 304 392C304 405.3 314.7 416 328 416L456 416C469.3 416 480 405.3 480 392C480 378.7 469.3 368 456 368L328 368z" />
        </svg>
      ),
    },
    {
      key: "confidence",
      icon: (
        <svg
          width="32"
          height="32"
          viewBox="0 0 640 640"
          fill={iconColor}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            opacity=".4"
            d="M32 96L32 384L188.4 514.3C211.4 533.5 240.4 544 270.3 544L286 544L279 537C269.6 527.6 269.6 512.4 279 503.1C288.4 493.8 303.6 493.7 312.9 503.1L353.9 544.1L362.9 544.1C382 544.1 400.7 539.8 417.7 531.8L391 505C381.6 495.6 381.6 480.4 391 471.1C400.4 461.8 415.6 461.7 424.9 471.1L456.9 503.1L474.4 485.6C483.3 476.7 485.9 463.8 482 452.5L344.1 315.7L329.2 330.6C279.9 379.9 200.1 379.9 150.8 330.6C127.8 307.6 126.9 270.7 148.6 246.6L255.4 128L215.8 128C190.3 128 165.9 138.1 147.9 156.1L144 160L32 96z"
          />
          <path d="M184.3 278.8L300.9 149.2C313.1 135.7 330.4 128 348.5 128L418.9 128C437.9 128 456.4 133.6 472.2 144.1L496 160L608 96L608 384L537.6 440L361 264.8C351.6 255.5 336.5 255.5 327.1 264.9L295.3 296.7C264.8 327.2 215.3 327.2 184.8 296.7C179.9 291.8 179.7 283.9 184.3 278.8z" />
        </svg>
      ),
    },
  ];

  const stepColor = "#1A56A8";
  const steps = [
    {
      key: "upload",
      title: (
        <b>
          {isPurchase
            ? t("maatwerkIntro.Uploadtext.titlePurchase")
            : t("maatwerkIntro.Uploadtext.title")}
        </b>
      ),
      text: isPurchase
        ? t("maatwerkIntro.Uploadtext.purchase")
        : t("maatwerkIntro.Uploadtext.rental"),
      icon: (
        <svg
          width="32"
          height="36"
          viewBox="0 0 640 640"
          fill={stepColor}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M160 240C160 178.1 210.1 128 272 128C311.3 128 345.8 148.2 365.8 178.8C370.2 185.5 378.9 187.9 386.1 184.5C397.5 179 410.4 176 424 176C472.6 176 512 215.4 512 264C512 278.1 508.7 291.4 502.8 303.2C500.8 307.3 500.6 312.1 502.3 316.3C504 320.5 507.5 323.9 511.8 325.4C549.2 338.5 576 374.2 576 416C576 469 533 512 480 512L176 512C114.1 512 64 461.9 64 400C64 346.3 101.8 301.4 152.2 290.5C156.5 289.6 160.3 286.9 162.5 283.1C164.7 279.3 165.4 274.8 164.2 270.5C161.5 260.8 160 250.6 160 240zM272 96C192.5 96 128 160.5 128 240C128 248 128.7 255.9 129.9 263.5C73 282.7 32 336.5 32 400C32 479.5 96.5 544 176 544L480 544C550.7 544 608 486.7 608 416C608 366.1 579.5 323 537.9 301.8C541.8 289.9 544 277.2 544 264C544 197.7 490.3 144 424 144C410.3 144 397.1 146.3 384.8 150.5C358.4 117.3 317.7 96 272 96zM331.3 260.7C325.1 254.5 314.9 254.5 308.7 260.7L236.7 332.7C230.5 338.9 230.5 349.1 236.7 355.3C242.9 361.5 253.1 361.5 259.3 355.3L304 310.6L304 432C304 440.8 311.2 448 320 448C328.8 448 336 440.8 336 432L336 310.6L380.7 355.3C386.9 361.5 397.1 361.5 403.3 355.3C409.5 349.1 409.5 338.9 403.3 332.7L331.3 260.7z" />
        </svg>
      ),
    },
    {
      key: "herkenning",
      title: <b>{t("maatwerkIntro.Herkenning")}</b>,
      text: t("maatwerkIntro.Herkenningtext"),
      icon: (
        <svg
          width="32"
          height="36"
          viewBox="0 0 640 640"
          fill={stepColor}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M320 96L192 96C174.3 96 160 110.3 160 128L160 512C160 529.7 174.3 544 192 544L448 544C465.7 544 480 529.7 480 512L480 256L384 256C348.7 256 320 227.3 320 192L320 96zM466.7 224L352 109.3L352 192C352 209.7 366.3 224 384 224L466.7 224zM128 128C128 92.7 156.7 64 192 64L325.5 64C342.5 64 358.8 70.7 370.8 82.7L493.3 205.3C505.3 217.3 512 233.6 512 250.6L512 512C512 547.3 483.3 576 448 576L192 576C156.7 576 128 547.3 128 512L128 128zM370.7 376C371.6 354.5 360.6 334.2 342.1 323.2C323.6 312.1 300.5 312.1 282 323.2C263.5 334.2 252.5 354.5 253.4 376C252.5 397.5 263.5 417.8 282 428.8C300.5 439.9 323.6 439.9 342.1 428.8C360.6 417.8 371.6 397.5 370.7 376zM361.9 448.5C347.7 458.3 330.5 464 312 464C263.4 464 224 424.6 224 376C224 327.4 263.4 288 312 288C360.6 288 400 327.4 400 376C400 394.5 394.3 411.7 384.5 425.9L427.3 468.7C433.5 474.9 433.5 485.1 427.3 491.3C421.1 497.5 410.9 497.5 404.7 491.3L361.9 448.5z" />
        </svg>
      ),
    },
    {
      key: "resultaten",
      title: <b>{t("maatwerkIntro.Resultaten")}</b>,
      text: t("maatwerkIntro.Resultatentext"),
      icon: (
        <svg
          width="32"
          height="36"
          viewBox="0 0 640 640"
          fill={stepColor}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M256 96L128 96C110.3 96 96 110.3 96 128L96 512C96 529.7 110.3 544 128 544L289.4 544C294.6 555.3 300.8 566 308 576L128 576C92.7 576 64 547.3 64 512L64 128C64 92.7 92.7 64 128 64L261.5 64C278.5 64 294.8 70.7 306.8 82.7L429.3 205.3C441.3 217.3 448 233.6 448 250.6L448 272.7C437 273.6 426.4 275.4 416 278.1L416 256.1L320 256.1C284.7 256.1 256 227.4 256 192.1L256 96.1zM402.7 224L288 109.3L288 192C288 209.7 302.3 224 320 224L402.7 224zM464 576C525.9 576 576 525.9 576 464C576 402.1 525.9 352 464 352C402.1 352 352 402.1 352 464C352 525.9 402.1 576 464 576zM464 320C543.5 320 608 384.5 608 464C608 543.5 543.5 608 464 608C384.5 608 320 543.5 320 464C320 384.5 384.5 320 464 320zM521.4 403.1C528.5 408.3 530.1 418.3 524.9 425.5L460.9 513.5C458.1 517.3 453.9 519.7 449.2 520C444.5 520.3 439.9 518.7 436.6 515.4L396.6 475.4C390.4 469.2 390.4 459 396.6 452.8C402.8 446.6 413 446.6 419.2 452.8L446 479.6L499 406.7C504.2 399.6 514.2 398 521.4 403.2z" />
        </svg>
      ),
    },
    {
      key: "controle",
      title: <b>{t("maatwerkIntro.Controle")}</b>,
      text: t("maatwerkIntro.Controletext"),
      icon: (
        <svg
          width="32"
          height="36"
          viewBox="0 0 640 640"
          fill={stepColor}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M94.6 317.6C98.4 307.5 96.9 296 90.5 287.3C73.6 264.4 64 237.1 64 208C64 131 133 64 224 64C315 64 384 131 384 208C384 285 315 352 224 352C206 352 188.8 349.3 172.8 344.5C166 342.4 158.7 342.7 152.1 345.2L72.6 375.5L94.6 317.7zM32 208C32 244.4 44 278.2 64.7 306.2L33.3 388.5C32.4 390.8 32 393.2 32 395.7C32 406.9 41.1 416 52.3 416C54.8 416 57.2 415.5 59.5 414.7L163.5 375.1C182.5 380.9 202.9 384 224.1 384C330.1 384 416.1 305.2 416.1 208C416.1 110.8 330 32 224 32C118 32 32 110.8 32 208zM416 576C437.2 576 457.5 572.9 476.6 567.1L580.6 606.7C582.9 607.6 585.4 608 587.8 608C599 608 608.1 598.9 608.1 587.7C608.1 585.2 607.6 582.8 606.8 580.5L575.5 498.2C596.1 470.1 608.2 436.3 608.2 400C608.2 317.6 546.5 248.5 463.2 229.3C462.1 240.1 460.3 250.6 457.6 260.8C527.4 277.5 576.2 335.2 576.2 400C576.2 429.1 566.6 456.4 549.7 479.3C543.3 488.1 541.7 499.5 545.6 509.6L567.6 567.4L488.1 537.1C481.5 534.6 474.2 534.3 467.4 536.4C451.4 541.3 434.2 543.9 416.2 543.9C337.1 543.9 274.6 493.2 259.6 429.4C249 430.9 238.2 431.7 227.3 431.8C243.7 513.7 322 575.8 416.1 575.8zM186.8 165.2C186.8 144.7 203.4 128 224 128C244.6 128 261.2 144.7 261.2 165.2C261.2 183 250.2 192.2 238 197.7C223.3 204.3 207.9 219.2 207.9 240C207.9 248.8 215.1 256 223.9 256C232.7 256 239.9 248.8 239.9 240C239.9 236.2 243.3 230.4 251 226.9C268.8 218.9 293.1 201 293.1 165.2C293.1 127 262.1 96 223.9 96C185.7 96 154.7 127 154.7 165.2C154.7 174 161.9 181.2 170.7 181.2C179.5 181.2 186.7 174 186.7 165.2zM224 324C235 324 244 315 244 304C244 293 235 284 224 284C213 284 204 293 204 304C204 315 213 324 224 324zM493.6 344.5C498.3 337 496 327.1 488.5 322.5C481 317.9 471.1 320.1 466.5 327.6L398.9 435.8L364.9 390.5C359.6 383.4 349.6 382 342.5 387.3C335.4 392.6 334 402.6 339.3 409.7L387.3 473.7C390.5 477.9 395.5 480.3 400.8 480.1C406.1 479.9 410.9 477.1 413.7 472.6L493.7 344.6z" />
        </svg>
      ),
    },
  ];

  return (
    <div
      className="mw-container"
      style={{ marginTop: 0, padding: mobile ? "24px 18px" : "36px 48px" }}
    >
      <Box>
        <Typography
          variant="h3"
          sx={{
            fontSize: { mobile: "30px", ipad: "48px" },
            color: "#1A56A8",
            fontWeight: 700,
            mb: 0.5,
            lineHeight: 1.2,
          }}
        >
          {isPurchase
            ? t("maatwerkIntro.title.purchase")
            : t("maatwerkIntro.title.rental")}
        </Typography>

        <Typography
          sx={{
            fontSize: { mobile: "18px", ipad: "22px" },
            color: "#454545",
            fontWeight: 600,
            mt: 0,
            lineHeight: 1.3,
          }}
        >
          {t("maatwerkIntro.subtitle")}
        </Typography>
      </Box>

      <Divider />

      <Box
        id="form-container"
        sx={{
          display: "flex",
          flexDirection: { mobile: "column", laptop: "row" },
          flexWrap: "wrap",
          gap: "40px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "24px",
            flex: 1.2,
            minWidth: { mobile: 0, ipad: "320px" },
          }}
        >
          <Typography
            sx={{
              fontSize: "16px",
              lineHeight: "1.8",
              color: "#1D1D1D",
              fontWeight: 600,
            }}
          >
            <Trans
              i18nKey={
                isPurchase
                  ? "maatwerkIntro.textLeftTopPurchase"
                  : "maatwerkIntro.textLeftTop"
              }
              values={{
                title: isPurchase
                  ? t("maatwerkIntro.title.purchase")
                  : t("maatwerkIntro.title.rental"),
              }}
              components={{
                b: <b></b>,
                br: (
                  <>
                    <br />
                    <br />
                  </>
                ),
              }}
            />
          </Typography>
          {mobile && (
            <Box sx={{ display: "flex", justifyContent: "center", my: 2 }}>
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#FF8C00",
                  fontSize: "18px",
                  padding: "8px 24px",
                  color: "#fff",
                  borderRadius: "8px",
                  textTransform: "none",
                }}
                onClick={handleNext}
              >
                {t("maatwerkIntro.startDeDemo")}
              </Button>
            </Box>
          )}
          <Typography
            sx={{
              fontSize: "16px",
              lineHeight: "1.8",
              color: "#1D1D1D",
              fontWeight: 600,
            }}
          >
            <Trans
              i18nKey={
                isPurchase
                  ? "maatwerkIntro.textLeftBottomPurchase"
                  : "maatwerkIntro.textLeftBottom"
              }
              components={{
                b: <b></b>,
                br: (
                  <>
                    <br />
                    <br />
                  </>
                ),
              }}
            />
          </Typography>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "20px",
              backgroundColor: "#EAF4FB",
              borderRadius: "16px",
              padding: "16px 20px",
            }}
          >
            <Box
              sx={{
                width: "40px",
                height: "40px",
                flexShrink: 0,
                borderRadius: "100%",
                backgroundColor: "#1A56A8",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 640 640"
                width="28"
                height="28"
                fill="#e0e0e0"
              >
                <path d="M331.6 68.5L539.1 149L558.3 156.4L559.5 176.9C562.4 226.9 554.6 303.2 522.2 377.8C489.5 453 431.1 527.8 332.8 570.3L320.1 575.8L307.4 570.3C208.9 527.9 150.6 453.2 117.9 377.9C85.5 303.3 77.7 226.9 80.6 177L81.8 156.5L101 149L308.5 68.5L320 64L331.6 68.5zM128.1 190C127.1 233.5 135 296.9 161.9 358.8C190.1 423.7 239 486.4 320 523.6C401.1 486.4 449.9 423.7 478.2 358.8C505 296.9 513 233.5 512 190L320 115.5L128.1 190zM430.4 234.7L416.3 254.1L313.8 394.9L297 418C288.2 408.9 266.1 386 230.8 349.4L214.1 332.1L248.6 298.8C258.1 308.6 272.5 323.5 291.8 343.5L377.4 225.8L391.5 206.4L430.3 234.6z" />
              </svg>
            </Box>
            <Typography
              sx={{
                fontSize: "16px",
                lineHeight: "1.5",
                color: "#1D1D1D",
                fontWeight: 600,
              }}
            >
              <b style={{ color: "#1A56A8" }}>
                {t("maatwerkIntro.resultLabel")}
              </b>{" "}
              {t("maatwerkIntro.resultText")}
            </Typography>
          </Box>

          <Box>
            <Typography
              variant="h5"
              sx={{
                fontSize: "20px",
                fontWeight: 700,
                color: "#1A56A8",
                marginBottom: "24px",
              }}
            >
              {isPurchase
                ? t("maatwerkIntro.whyTitlePurchase")
                : t("maatwerkIntro.whyTitle")}
            </Typography>
            <Box
              sx={{
                display: "flex",
                flexWrap: { mobile: "wrap", ipad: "nowrap" },
                justifyContent: "center",
                gap: { mobile: "20px 12px", ipad: "10px" },
              }}
            >
              {whyItems.map((item) => (
                <Box
                  key={item.key}
                  sx={{
                    flex: { mobile: "0 0 28%", ipad: 1 },
                    minWidth: 0,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    textAlign: "center",
                    gap: "10px",
                  }}
                >
                  <Box
                    sx={{
                      width: { mobile: "48px", ipad: "60px" },
                      height: { mobile: "48px", ipad: "60px" },
                      flexShrink: 0,
                      borderRadius: "100%",
                      backgroundColor: "#EAF4FB",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {item.icon}
                  </Box>
                  <Typography
                    sx={{
                      fontSize: { mobile: "12px", ipad: "14px" },
                      lineHeight: "1.35",
                      color: "#454545",
                      fontWeight: 600,
                    }}
                  >
                    {t(
                      `maatwerkIntro.${isPurchase ? "whyPurchase" : "why"}.${
                        item.key
                      }`
                    )}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
        <Divider
          orientation="vertical"
          flexItem
          sx={{
            display: { mobile: "none", laptop: "block" },
            ml: "60px",
            mr: "35px",
          }}
        />
        <Box
          sx={{
            flex: 1,
            minWidth: { mobile: 0, ipad: "320px" },
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h5"
            gutterBottom
            sx={{
              fontSize: "20px",
              fontWeight: 700,
              color: "#1A56A8",
              marginBottom: "28px",
            }}
          >
            {t("maatwerkIntro.subtitleRight")}
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {steps.map((step, index) => (
              <Box key={step.key} sx={{ display: "flex", gap: "24px" }}>
                {/* icon rail with connecting line */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    flexShrink: 0,
                  }}
                >
                  <Box
                    sx={{
                      width: "66px",
                      height: "66px",
                      flexShrink: 0,
                      borderRadius: "100%",
                      backgroundColor: "#EAF4FB",
                      boxShadow: "0 0 0 6px #F3F9FD",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {step.icon}
                  </Box>
                  {index < steps.length - 1 && (
                    <Box
                      sx={{
                        width: "2px",
                        flex: 1,
                        minHeight: "24px",
                        backgroundColor: "#D6E6F5",
                        my: "8px",
                      }}
                    />
                  )}
                </Box>
                <Box
                  sx={{
                    flex: 1,
                    pb: index < steps.length - 1 ? "28px" : 0,
                    pt: "6px",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "18px",
                      fontWeight: 700,
                      color: "#1A56A8",
                      lineHeight: 1.3,
                      mb: "6px",
                    }}
                  >
                    {index + 1}. {step.title}
                  </Typography>
                  <Typography
                    sx={{
                      lineHeight: "1.6",
                      fontSize: "16px",
                      fontWeight: 400,
                      color: "#454545",
                    }}
                  >
                    {step.text}
                  </Typography>
                </Box>
              </Box>
            ))}
          </Box>

          <Box
            sx={{
              marginTop: "auto",
              paddingTop: "32px",
              display: "flex",
              flexDirection: "column",
              alignItems: { mobile: "center", laptop: "flex-end" },
              gap: "10px",
            }}
          >
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#FF8C00",
                color: "#fff",
                borderRadius: "8px",
                textTransform: "none",
                fontSize: "17px",
                fontWeight: 600,
                padding: "10px 48px",
              }}
              onClick={handleNext}
            >
              {t("maatwerkIntro.startDeDemo")}
            </Button>
            <Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <svg
                width="12"
                height="14"
                viewBox="0 0 12 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 0C4.34 0 3 1.34 3 3v2H2.5A1.5 1.5 0 0 0 1 6.5v6A1.5 1.5 0 0 0 2.5 14h7a1.5 1.5 0 0 0 1.5-1.5v-6A1.5 1.5 0 0 0 9.5 5H9V3c0-1.66-1.34-3-3-3Zm1.5 5h-3V3a1.5 1.5 0 0 1 3 0v2Z"
                  fill="#7A8794"
                />
              </svg>
              <Typography
                sx={{ fontSize: "13px", color: "#7A8794", fontWeight: 500 }}
              >
                {t("maatwerkIntro.trust")}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default MaatwerkIntro;
